import { useCallback } from 'react';

import { TCustomSelectProps } from '../custom-select.types';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';

const useGetInputPadding = ({
  inputPadding,
  selectedOptions,
  design,
  isFocused,
  displayingDropdownIcon,
}: {
  design: TCustomSelectProps['design'];
  inputPadding: TCustomSelectProps['inputPadding'];
  selectedOptions: TReactSelectOption[];
  isFocused: boolean;
  displayingDropdownIcon?: boolean;
}) => {
  return useCallback(() => {
    if (inputPadding) {
      if (typeof inputPadding === 'function') {
        return inputPadding(selectedOptions);
      }
      return inputPadding;
    }

    // standard design always shows the border/icon; focused always shows it too
    const iconVisible = design === 'standard' || isFocused || displayingDropdownIcon;
    const rightPadding = iconVisible ? '32px' : '8px';

    if (design === 'flat') {
      return `0 ${rightPadding} 0 8px`;
    }

    if (isFocused && selectedOptions.length) {
      return '0 32px 0 8px';
    }

    return `0 ${rightPadding} 0 16px`;
  }, [design, displayingDropdownIcon, inputPadding, isFocused, selectedOptions]);
};

export default useGetInputPadding;
